module.exports = "<label [ngClass]=\"position === 1 ? '' : _captionWidth\">{{ caption }}</label>\r\n\r\n<div [ngClass]=\"position === 1 ? '' : _fieldWidth\">\r\n    <input [type]=\"type\" [disabled]=\"disabled\" class=\"form-control ixsControl\" [(ngModel)]=\"value\" (blur)=\"onBlur()\" (keydown)=\"onKeyDown($event)\" />\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/date/date.component.html
// module id = 1187
// module chunks = 322